{
  "removeButtonLabel": "Премахване",
  "removeDescription": "Натиснете Delete, за да премахнете маркера."
}
